import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-reset-password',
  template: require('./reset-password.component.html'),
  styles: [require('./reset-password.component.sass')]
})
export class ResetPasswordComponent implements OnInit {

  @ViewChild('passwordResetModal') passwordResetModal: ElementRef;

  passwordResetForm: FormGroup;
  passwordResetModalReference: NgbModalRef;
  @Output() reset = new EventEmitter<string>();


  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {
    this.passwordResetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
   }

  ngOnInit(): void {
  }

  async showModal() {
    this.passwordResetForm.reset();
    this.passwordResetModalReference = await this.modalService.open(this.passwordResetModal, { 
      backdrop: 'static'
    })
  }

  onReset = () => {
    if (this.passwordResetForm.valid) {
      this.reset.emit(this.passwordResetForm.value && this.passwordResetForm.value.email);
      this.cancel();
    }
  }

  cancel = () => {
    this.passwordResetModalReference.close();
  }

}
